import { useFormik, Form, FormikProvider } from "formik";
import { Button, Input, Select } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { updateDocumentByID } from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import axios from "apis/axios";
import { useCallback, useEffect, useState } from "react";
import ReactSelect from "react-select";
import Add from "./Add"
const AddUser = ({ handleClick, data }) => {
  const frequencies = [
    {
      label: "Daily",
      value: "daily",
    },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "Monthly" },
  ];
  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: {
      report: data?.report,
      email: data?.email,
      frequency: data?.frequency,
    },
    onSubmit: async (values) => {
      try {
        const apiResponse = await updateDocumentByID(
          "email-scheduler",
          data._id,
          {
            report: values.report.trim().toLowerCase(),
            email: values.email.trim().toLowerCase(),
            frequency: values.frequency.trim().toLowerCase(),
          }
        );
        if (apiResponse) {
          toast.success("Successfully saved");
          queryClient.invalidateQueries("email-scheduler");
          handleClick();
        }
      } catch (error) {
        console.log(error);
        return null;
      }
    },

    validate: (values) => {
      let errors = {};
      if (!values.frequency) errors.frequency = "Required";
      if (!values.email) errors.email = "Required";
      if (!values.report) errors.report = "Required";
      return errors;
    },
  });

  return (
    <Add handleClick= {handleClick} emailEntity={data}/>
  );
};
export default AddUser;
